import React from 'react';
import styled from 'styled-components';

import { Breakpoints } from '../theme/Breakpoints';
import { FontSize } from '../theme/FontSize';
import { Spacing } from '../theme/Spacing';
import { Empty } from '../utils/local-antd';
import { Button } from './Button';
import { Text } from './Text';

const StyledButton = styled(Button)`
  font-size: ${FontSize.m};
  padding: ${Spacing.s} ${Spacing.xxxl};

  @media (max-width: ${Breakpoints.DESKTOP}) {
    padding: ${Spacing.s} ${Spacing.xl};
  }

  &:hover {
    background-color: ${({ theme }) => theme.lightMain};
  }
`;

const StyledEmpty = styled(Empty)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  .ant-empty-image {
    display: none;
  }
`;

type AtiraEmptyWithActionProps = {
  description: string;
  buttonTitle: string;
  onClick: VoidFunction;
  buttonWidth?: React.CSSProperties['width'];
};
export const AtiraEmptyWithAction: React.FC<AtiraEmptyWithActionProps> = ({
  buttonTitle,
  description,
  onClick,
  buttonWidth,
}) => {
  return (
    <StyledEmpty
      image={null}
      description={
        <Text color="main" fontSize="l" align="center" fontWeight={'bold'}>
          {description}
        </Text>
      }
    >
      <StyledButton onClick={onClick} width={buttonWidth}>
        {buttonTitle}
      </StyledButton>
    </StyledEmpty>
  );
};
